import { useRef, useCallback, useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMatchMedia, BreakPointsEnum } from "@perxis-auto/shared";
import { useFilterValues } from "../../../features/filterValues/lib/api/hooks/useFilterValues.js";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "react-router";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import { useAppDispatch } from "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import "../../../shared/store/installation/model/slice.js";
import "../../../shared/store/pagination/model/slice.js";
import "../../../features/filterChoice/model/middleware/index.js";
import "../../../features/filterChoice/model/selectors/selectFilterHistory.js";
import "../../../features/filterChoice/model/selectors/selectFilterSortValue.js";
import "../../../features/filterChoice/model/selectors/selectFilterValuesCount.js";
import { selectIsFilterPanelVisible } from "../../../features/filterChoice/model/selectors/selectIsFilterPanelVisible.js";
import { selectIsFilterValuesSelected } from "../../../features/filterChoice/model/selectors/selectIsFilterValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectIsInitialSortValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectIsValidSortValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectSlugedFilterValues.js";
import { actions as actions$1 } from "../../../features/filterChoice/model/slice.js";
import "../../../features/filterValues/api/api.js";
import "../../../features/filterValues/model/middleware/index.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../features/filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableValues.js";
import "../../../features/filterValues/model/selectors/selectFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterItems.js";
import "../../../features/filterValues/model/selectors/selectFilterValuesFields.js";
import "../../../features/filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import { selectIsFilterValuesMissing } from "../../../features/filterValues/model/selectors/selectIsFilterValuesMissing.js";
import { useConstructorContext } from "../../../shared/context/constructor.js";
import "../../../shared/context/this.js";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
import { useAdjustedFilterPanelLayout } from "../lib/useAdjustedFilterPanelLayout.js";
import { useAvailableHeight } from "../lib/useAvailableHeight.js";
import { selectActiveGroups } from "./selectors/selectActiveGroups.js";
import { actions } from "./slice.js";
const useContainer = (item) => {
  const props = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { layout, widgets } = useConstructorContext();
  const dispatch = useAppDispatch();
  const { t } = useTranslation(APP.name);
  const asideRef = useRef(null);
  const { height: asideHeight } = useAvailableHeight(asideRef);
  const resolvedLayout = useAdjustedFilterPanelLayout(layout);
  const isMobile = useMatchMedia(BreakPointsEnum.smMax);
  const isFilterValuesSelected = useAppSelector(selectIsFilterValuesSelected);
  const isFilterPanelVisible = useAppSelector(selectIsFilterPanelVisible);
  const isFilterValuesMissing = useAppSelector(selectIsFilterValuesMissing);
  const activeGroups = useAppSelector(selectActiveGroups);
  const { isLoading, isUninitialized } = useFilterValues();
  const onGroupsChange = useCallback(
    (changedGroups) => {
      dispatch(actions.setActiveGroups(changedGroups));
    },
    [dispatch]
  );
  const onToggle = useCallback(() => {
    dispatch(actions$1.setIsVisible(!isFilterPanelVisible));
  }, [dispatch, isFilterPanelVisible]);
  const onReset = useCallback(() => {
    dispatch(actions$1.resetValues());
  }, [dispatch]);
  const items = useMemo(() => {
    return [...resolvedLayout.items].filter(({ isHidden }) => !isHidden);
  }, [resolvedLayout.items]);
  const isFilterValuesLoading = isLoading || isUninitialized;
  useEffect(() => {
    if (isMobile && isFilterPanelVisible) {
      dispatch(actions$1.setIsVisible(!isFilterPanelVisible));
    } else if (!isMobile && !isFilterPanelVisible) {
      dispatch(actions$1.setIsVisible(!isFilterPanelVisible));
    }
  }, [isMobile]);
  return {
    ...props,
    layout: resolvedLayout,
    widgets,
    onToggle,
    onReset,
    isVisible: isFilterPanelVisible && !isFilterValuesMissing,
    isMobile: !!isMobile,
    isLoading: isFilterValuesLoading,
    hasFooter: isFilterValuesSelected,
    asideRef,
    asideHeight,
    onGroupsChange,
    activeGroups,
    items,
    t
  };
};
export {
  useContainer
};
